'use strict';

/* Views */
import ForumOverview from './overview/overview.component';
import ForumList from './list/post-list.component';
import ForumPost from './post/post.component';

/* Components */
import PostEditComponent from '../../components/forum/edit/post-edit.component';

/* Services */
import ForumService from '../../services/forum/forum.service';

export default angular.module('conduuApp.forum', [ForumOverview, ForumList, ForumPost, PostEditComponent, ForumService])
  .name;



// WEBPACK FOOTER //
// ./client/app/forum/index.js